/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Box } from "@mui/material";
import { createUseStyles } from "react-jss";
import { useMemo } from "react";
import { theme } from "$utils/theme/bataillog";
import { Reception } from "$types";

// import { useList } from "$hooks/useList";

// import ReferenceType from "$types/ReferenceType";
// import { ProductReference } from "$types/ProductReference";
// import { Services } from "$utils/typeConstants";

import ProductReferenceItem from "./ProductReferenceItem";

const ITEM_PER_ROW = 2;

type Props = {
  productRefFields: any[];
  companyId: string;
  hasReferencingCategory: boolean;
  isReadOnly?: boolean;
  nestIndex: number;
  reception: Reception;
  openDeleteModal: boolean;
  confirmedDeletions: boolean;
  deletedItems: number[];
  setDeletedItems: React.Dispatch<React.SetStateAction<number[]>>;
};

function ProductReferenceList({
  productRefFields,
  companyId,
  hasReferencingCategory,
  isReadOnly,
  nestIndex,
  reception,
  openDeleteModal,
  confirmedDeletions,
  deletedItems,
  setDeletedItems,
}: Props) {
  const classes = useStyles();

  // Get the suborder reference for filtering
  // const suborderReference = useMemo(() => {
  //   return productRefFields.find((p) => !!p.suborderReferences)
  //     ?.suborderReferences[0];
  // }, [productRefFields]);

  // const { data: otherReceptionsData = [] } = useList<
  //   Reception & { id: number | string }
  // >(
  //   "api/order/receptions/consolidated", // Use the consolidated endpoint
  //   {
  //     defaultPageSize: 999999,
  //     defaultFilters: {
  //       company: { $eq: companyId },
  //       productQuantity: { suborderReference },
  //       id: { $ne: reception.id },
  //     },
  //     populate: ["productQuantity", "receptionReferences"],
  //     service: Services.GATEWAY_API,
  //   }
  // );

  // Process the response data with proper type handling
  // const otherReceptions = useMemo(() => {
  //   if (!otherReceptionsData) return [] as Reception[];

  //   if (Array.isArray(otherReceptionsData))
  //     return otherReceptionsData as Reception[];

  //   if (
  //     "data" in otherReceptionsData &&
  //     // @ts-ignore
  //     Array.isArray(otherReceptionsData.data)
  //   )
  //     // @ts-ignore
  //     return otherReceptionsData.data;

  //   return [] as Reception[];
  // }, [otherReceptionsData]);

  // Filter for the suborderReference client-side
  // const filteredReceptions = useMemo(() => {
  //   if (!otherReceptions || otherReceptions.length === 0)
  //     return [] as Reception[];

  //   return otherReceptions.filter((receptionItem) => {
  //     // Guard against undefined productQuantity
  //     if (
  //       !receptionItem.productQuantity ||
  //       !Array.isArray(receptionItem.productQuantity)
  //     )
  //       return false;

  //     return receptionItem.productQuantity.some(
  //       (pq) => pq.suborderReference === suborderReference
  //     );
  //   });
  // }, [otherReceptions, suborderReference]);

  // Used to fill the flex gap at the end
  const remainder = productRefFields.length % ITEM_PER_ROW;
  const invisibleItemsNb = remainder === 0 ? 0 : ITEM_PER_ROW - remainder;

  /**
   * @param {ProductReference} productReference
   * @returns {number} quantity already referenced in previous receptions
   */
  // const getReferencedQuantity = useCallback(
  //   (productReference: ProductReference) => {
  //     const { suborders, originalProductReference } = productReference;
  //     const suborder = suborders[0];

  //     return filteredReceptions.reduce((referencedQty, reception) => {
  //       const productQuantity = Array.isArray(reception.productQuantity)
  //         ? reception.productQuantity
  //         : [];

  //       const receptionReferences = Array.isArray(reception.receptionReferences)
  //         ? reception.receptionReferences
  //         : [];

  //       const referencedProductRefs = receptionReferences.reduce((refs, rr) => {
  //         if (
  //           rr.referenceType === ReferenceType.PRODUCT &&
  //           rr.originalProductReference === originalProductReference
  //         ) {
  //           return [...refs, rr.productReference];
  //         }
  //         return refs;
  //       }, [] as string[]);

  //       const receptionTotalQty = productQuantity.reduce((acc, pq) => {
  //         if (
  //           pq.suborderReference === suborder.reference &&
  //           referencedProductRefs.includes(pq.productId)
  //         ) {
  //           return acc + (pq.receivedQuantity || 0);
  //         }
  //         return acc;
  //       }, 0);

  //       return referencedQty + receptionTotalQty;
  //     }, 0);
  //   },
  //   [filteredReceptions]
  // );

  // Filter out deleted items

  const filteredProductReferences = useMemo(() => {
    return productRefFields.filter((p) => !deletedItems.includes(p.id));
  }, [productRefFields, deletedItems]);

  return (
    <Box className={classes.wrapper}>
      {filteredProductReferences.map((productReference, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <Box key={productReference.reference + i} className={classes.item}>
          <ProductReferenceItem
            companyId={companyId}
            confirmedDeletions={confirmedDeletions}
            hasReferencingCategory={hasReferencingCategory}
            isReadOnly={isReadOnly}
            listIndex={nestIndex}
            nestIndex={i}
            productReference={productReference}
            reception={reception}
            openDeleteModal={openDeleteModal}
            setDeletedItems={setDeletedItems}
            // referencedQuantity={getReferencedQuantity(productReference)}
          />
        </Box>
      ))}
      {Array.from({ length: invisibleItemsNb }, (_, index) => (
        <Box key={`invisible-${nestIndex}-${index}`} className={classes.item} />
      ))}
    </Box>
  );
}

const useStyles = createUseStyles(() => ({
  wrapper: {
    display: "flex",
    flexWrap: "wrap",
    columnGap: `${theme.spacing(2)}px`,
    rowGap: `${theme.spacing(2)}px`,
    width: "100%",
  },
  item: {
    display: "flex",
    flex: `0 0 calc((100% - ${theme.spacing(2)}px) / ${ITEM_PER_ROW})`,
    minWidth: 0,
    "& > *": {
      width: "100%",
      minWidth: 0,
    },
  },
}));

export default ProductReferenceList;
